/**
 * Product Quantity Management
 * Gestion de la quantité et calcul du prix total pour les produits WooCommerce
 */

export function initProductQuantity() {
    const quantityInput = document.querySelector('[data-quantity-input]');
    const quantityMinus = document.querySelector('[data-quantity-minus]');
    const quantityPlus = document.querySelector('[data-quantity-plus]');
    const totalPriceElement = document.querySelector('[data-total-price]');

    // Vérifier si les éléments nécessaires existent
    if (!totalPriceElement) {
        console.warn('Product quantity: Prix total element not found');
        return;
    }

    // Récupérer le prix de base depuis l'attribut data ou le contenu
    let basePrice = 0;
    const priceData = totalPriceElement.getAttribute('data-base-price');
    if (priceData) {
        basePrice = parseFloat(priceData);
    } else {
        // Fallback: extraire le prix depuis le contenu textuel
        const priceText = totalPriceElement.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
        basePrice = parseFloat(priceText) || 0;
    }

    console.log('Product quantity initialized with base price:', basePrice);

    /**
     * Met à jour le prix total basé sur la quantité
     */
    function updateTotalPrice() {
        if (!quantityInput) return;
        
        const quantity = parseInt(quantityInput.value) || 1;
        const total = (basePrice * quantity).toFixed(2);
        totalPriceElement.textContent = total + '€';
    }

    // Vérifier si les contrôles sont disponibles
    if (!quantityInput || quantityInput.disabled) {
        // Même si le produit n'est pas disponible, afficher le prix de base avec 2 décimales
        if (totalPriceElement && basePrice > 0) {
            totalPriceElement.textContent = parseFloat(basePrice).toFixed(2) + '€';
        }
        console.log('Product quantity: Controls disabled or not available');
        return; // Arrêter l'initialisation si le produit n'est pas disponible
    }

    // Bouton moins
    if (quantityMinus && !quantityMinus.disabled) {
        quantityMinus.addEventListener('click', function() {
            const currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
                updateTotalPrice();
            }
        });
    }

    // Bouton plus
    if (quantityPlus && !quantityPlus.disabled) {
        quantityPlus.addEventListener('click', function() {
            const currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
            updateTotalPrice();
        });
    }

    // Input direct
    if (quantityInput && !quantityInput.disabled) {
        quantityInput.addEventListener('input', function() {
            if (this.value < 1) {
                this.value = 1;
            }
            updateTotalPrice();
        });
    }

    // Mise à jour initiale seulement si disponible
    if (quantityInput && !quantityInput.disabled) {
        updateTotalPrice();
    }
}
